import axios from '@axios'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSuppliers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/suppliers/', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchSupplier(ctx,{id}) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/suppliers/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    editSupplier(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/suppliers', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteSupplier(ctx, queryParams) {
      return new Promise((resolve, reject) => {
         axiosIns.delete('/suppliers', { params: queryParams })
         .then(response=>resolve(response))
         .catch(error=>reject(error))
      })
    },
    exportSuppliers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/suppliers/export', { params: queryParams, responseType: "blob" })
        .then(response=>resolve(response))
        .catch(error=>reject(error))
      })
    }
  },
}
